import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import normalizePhoneNumber from "../utils/normalizePhoneNumber";
import { decryptToken } from "../utils/getToken";

const AddAdmission2 = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const token = decryptToken("accessToken") || ""
    const submittedData = location.state || null;
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    console.log(submittedData)
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        fatherName: "",
        motherName: "",
        dob: "",
        aadhar: "",
        gender: "",
        school: "",
        address: "",
        pincode: "",
        mobile: "",
        email: "",
        center: "",
        main_id: isLoggedIn?.main_id || "",
        status: ""
    });
    

    /* ------------------ Helpers ------------------ */

    const formatToInputDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return isNaN(date) ? "" : date.toISOString().split("T")[0];
    };

    /* ------------------ Input Handler ------------------ */

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "mobile") {
            setFormData((prev) => ({
                ...prev,
                mobile: normalizePhoneNumber(value),
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    /* ------------------ Prefill on Edit ------------------ */

    useEffect(() => {
        if (submittedData) {
            setFormData({
                id: submittedData.id || "",
                name: submittedData.name || "",
                fatherName: submittedData.fatherName || "",
                motherName: submittedData.motherName || "",
                dob: formatToInputDate(submittedData.dob),
                aadhar: submittedData.aadhar || "",
                gender: submittedData.gender || "",
                school: submittedData.school || "",
                address: submittedData.address || "",
                pincode: submittedData.pincode || "",
                mobile: submittedData.mobile || "",
                email: submittedData.email || "",
                center: submittedData.center || "",
                main_id: isLoggedIn?.main_id || "",
                status: submittedData.status || ""
            });
        }
    }, []);

    /* ------------------ Submit ------------------ */

    const handleSubmit = async (e) => {
        e.preventDefault();

        const method = formData.id ? "PUT" : "POST";
        const apiUrl = formData.id
            ? `${url}/admission/${formData.id}`
            : `${url}/admission/admin`;

        try {
            const res = await fetch(apiUrl, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization":`Bearer ${token}`
                },
                body: JSON.stringify(formData),
            });

            const result = await res.json();

            if (res.ok) {
                alert(`Admission ${formData.id ? "updated" : "created"} successfully`);
                navigate("/admission");
            } else {
                alert(result.message || "Submission failed");
            }
        } catch (err) {
            console.error(err);
            alert("Server error");
        }
    };

    /* ------------------ JSX ------------------ */

    return (
        <div >
            <form className="oms-modal-form" onSubmit={handleSubmit}>
                <div className="oms-form-flex">

                    {/* Name */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    {/* Father */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Father Name</label>
                        <input
                            type="text"
                            name="fatherName"
                            value={formData.fatherName}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Mother */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Mother Name</label>
                        <input
                            type="text"
                            name="motherName"
                            value={formData.motherName}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Email */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Mobile */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Phone Number</label>
                        <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            maxLength="10"
                        />
                    </div>

                    {/* DOB */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Date of Birth</label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Aadhar */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Aadhar</label>
                        <input
                            type="text"
                            name="aadhar"
                            value={formData.aadhar}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* School */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">School</label>
                        <input
                            type="text"
                            name="school"
                            value={formData.school}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Address */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Address</label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Pincode */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Pincode</label>
                        <input
                            type="text"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* Gender */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Gender</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                        >
                            <option value="">Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Transgender">Transgender</option>
                        </select>
                    </div>

                    {/* Center */}
                    <div className="oms-form-group">
                        <label className="oms-form-label">Center</label>
                        <select
                            name="center"
                            value={formData.center}
                            onChange={handleInputChange}
                        >
                            <option value="">Select</option>
                            <option value="Airoli">Airoli</option>
                            <option value="Kandivali">Kandivali</option>
                            <option value="Naigaon">Naigaon</option>
                            <option value="Ghansoli">Ghansoli</option>
                            <option value="Goregoan West">Goregoan West</option>
                        </select>
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Status</label>
                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                        >
                            <option value="">Select</option>
                            <option value="Paid">Paid</option>
                            <option value="Deactive">Deactive</option>
                        </select>
                    </div>
                </div>

                {/* Actions */}
                <div className="oms-form-actions">
                    <button type="submit">
                        {formData.id ? "Update" : "Create"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddAdmission2;
